import { BrandIntegrationType } from '../enums/brand-integration-type.enum';

export class BrandDetails {
  brandUuid: string;
  displayName: string;
  planCount: number;
  consumerCount: number;
  simCount: number;
  hasBlankSims: boolean;
  integrationType: BrandIntegrationType;
}
